import ReactPlayer from "react-player";
import { FaRegHeart, FaHeart, FaPaperPlane } from "react-icons/fa";
import { Checkbox } from "@mui/material";
import blankProfile from "../images/blank-profile.png";
import { useState } from "react";
import {
  addComment,
  likeDislikePost,
  selectVideo,
  toggleCoachesAthletesListPopup,
} from "../../../Redux/Actions/FeedPageActions";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { CircularProgress } from "@material-ui/core";
import { openFailDialog } from "../../../Redux/Actions/PopupActions";
import { userRoleKeyMap } from "../../../utils/constant";
const FeedPostCard = ({ post: item }) => {
  const schoolId = getFromLocalStorage("schoolId");
  const permissionRights = useSelector(({ loggedInUser }) =>
    loggedInUser.userProfile.permissionRights.map((item) => item.displayName)
  );
  const userInfo = useSelector(({ loggedInUser }) => {
    const role = loggedInUser.role;
    const user = loggedInUser[userRoleKeyMap[role]];
    return {
      profileImage: user.uploadedLogo
        ? user.uploadedLogo.filePath
        : blankProfile,
      userName: user.firstName + " " + user.lastName,
    };
  });
  const [showComments, setShowComments] = useState(false);
  const [displayCount, setDisplayCount] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState({
    likeDislike: false,
    comment: false,
  });
  const dispatch = useDispatch();

  const handlePostLikeDislike = (postId, status) => {
    setLoading((loading) => ({
      ...loading,
      likeDislike: true,
    }));
    likeDislikePost(dispatch, { postId, status }).then(() => {
      setLoading((loading) => ({
        ...loading,
        likeDislike: false,
      }));
    });
  };

  const handlePostComment = (postId) => {
    setLoading((loading) => ({
      ...loading,
      comment: true,
    }));
    addComment(dispatch, {
      postId,
      commentMessage: comment,
      schoolId,
      userName: userInfo?.userName,
    }).then(() => {
      setComment("");
      setShowComments(true);
      setLoading((loading) => ({
        ...loading,
        comment: false,
      }));
    });
  };

  const handleShare = () => {
    if (permissionRights.includes("Exchange Videos")) {
      toggleCoachesAthletesListPopup(dispatch, true);
      selectVideo(dispatch, {
        eventId: item?.event?.id,
        eventMediaId: item?.eventMedia?.id,
        scheduleId: item?.eventMedia?.scheduleEvent?.id,
      });
    } else {
      openFailDialog(dispatch, {
        open: true,
        message: "You Don't Have Permission To Share Videos.",
      });
    }
  };

  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0 main-card-box mb-3">
      <div className="row m-0">
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-11">
          <div className="row">
            <div className="clear10 col-md-12"></div>
            <div className="col-2 col-sm-2 col-md-4 col-lg-2 plrone">
              <img
                className="hwbr"
                src={
                  item?.school?.uploadedLogo
                    ? item?.school?.uploadedLogo?.filePath
                    : blankProfile
                }
                alt="Coaches"
              />
            </div>
            <div className="col-10 col-sm-10 col-md-8 col-lg-8 pl-0">
              <h6 className="fs-16 bold dgrey-new m-0 ml-2">
                {item?.school?.schoolName}
              </h6>
              <label className="fs-14 medium black ml-1">
                {item?.lastSeen}
              </label>
            </div>
          </div>
        </div>
        <div className="col-1 col-sm-1 col-md-2 col-lg-2 p-11 ml-auto text-right"></div>
      </div>
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
        <label className="fs-20 bold dgrey-new m-0 mobofs20">
          {item?.videoTitle}
        </label>
        <p className="fs-14 feed-text">
          {item?.videoDescription}
          <span className="link cp"></span>
        </p>
      </div>
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0" id="feedimage">
        <div className="clear20"></div>
        {item?.eventMedia && (
          <ReactPlayer
            id="videoPlayer"
            playing={false}
            url={item?.eventMedia?.videoPath}
            controls
          />
        )}
      </div>
      <div className="clear10"></div>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div>
                <Checkbox
                  icon={<FaRegHeart className="fs-22" />}
                  checkedIcon={<FaHeart className="fs-22 red" />}
                  checked={item?.isLikedFlag}
                  disabled={loading?.likeDislike}
                  onChange={(e) => {
                    handlePostLikeDislike(item?.shareMediaId, e.target.checked);
                  }}
                />
                <span className="fs-16 bold black pl-2">Like</span>
              </div>
              <div className="feed-share">
                <FaPaperPlane
                  className="fs-22 mg-right-5 cp"
                  onClick={handleShare}
                />
                <span className="fs-16 bold black pl-2 mobofs16">Share</span>
              </div>
            </div>
            <div className="pl-0 ">
              <div className="d-flex">
                <span className="fs-16 bold black mobofs16 count-likes">
                  {item?.likedCount ? item?.likedCount : 0} Likes
                </span>
                <span
                  className="fs-16 bold black cp mobofs16 feed-cmnt"
                  onClick={() => {
                    if (item?.commentCount !== 0) {
                      setShowComments((showComments) => !showComments);
                    }
                  }}
                >
                  {item?.commentCount ? item?.commentCount : 0} Comments
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row padIn15 pt-4 padBottom">
        <div className="col-10 col-lg-10 col-sm-10">
          <input
            type="text"
            className="post_input"
            placeholder="Add Comment"
            onChange={(event) => {
              setComment(event.target.value);
            }}
            value={comment}
          />
        </div>
        <div className="col-lg-2 col-2 col-sm-2">
          <button
            variant="contained"
            size="small"
            disabled={loading?.comment || comment?.length === 0}
            className="postBTN"
            onClick={() => {
              handlePostComment(item?.shareMediaId);
            }}
          >
            {loading?.comment ? (
              <CircularProgress
                size="1.5rem"
                color="#002244"
                style={{ marginTop: "4px" }}
              />
            ) : (
              "Post"
            )}
          </button>
        </div>
      </div>

      {showComments && (
        <div className="Box padIn15">
          {item?.commentMediaDetailsList
            ?.slice(0, displayCount)
            .map((data, index) => (
              <div key={index}>
                <div className="mt-2">
                  <div className="commentname">
                    {data.name}{" "}
                    <li className="timecomment">{data?.lastSeen}</li>
                  </div>
                  <p className="commentsubtext">{data.commentMessage}</p>
                </div>
              </div>
            ))}
          {displayCount < item?.commentMediaDetailsList?.length && (
            <p
              className="morecomment mb-1 pb-0 cp mt-3"
              onClick={() => {
                setDisplayCount((count) => count + 5);
              }}
            >
              Load More Comments
            </p>
          )}
          <div className="clear10"></div>
          <button
            className="morecomment mb-0 pb-0 cp"
            onClick={() => {
              setShowComments(false);
              setDisplayCount(5);
            }}
          >
            Hide Comments
          </button>
        </div>
      )}
      <div className="clear20"></div>
    </div>
  );
};

export default FeedPostCard;
